import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function MerciSatisfactionPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirection automatique après 5 secondes
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-blue-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Animation de succès */}
        <div className="relative mb-8">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
            <i className="ri-check-line text-4xl text-green-600"></i>
          </div>
          <div className="absolute inset-0 w-24 h-24 bg-green-200 rounded-full mx-auto animate-ping opacity-25"></div>
        </div>

        {/* Message principal */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">
            Merci pour votre retour !
          </h1>
          
          <div className="space-y-3 text-gray-600">
            <p className="text-lg">
              🎉 Votre questionnaire de satisfaction a été enregistré avec succès.
            </p>
            
            <p>
              Votre avis est précieux et nous aide à améliorer continuellement nos formations.
            </p>
            
            <div className="bg-purple-50 rounded-xl p-4 mt-6">
              <p className="text-sm text-purple-800 font-medium">
                <i className="ri-information-line mr-2"></i>
                Vous allez être redirigé vers l'accueil dans quelques secondes...
              </p>
            </div>
          </div>
        </div>

        {/* Boutons d'action */}
        <div className="space-y-3">
          <button
            onClick={() => navigate('/')}
            className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white py-4 rounded-xl font-semibold hover:from-purple-700 hover:to-blue-700 transition-all duration-300 shadow-lg"
          >
            <i className="ri-home-line mr-2"></i>
            Retour à l'accueil
          </button>
          
          <button
            onClick={() => navigate('/satisfaction')}
            className="w-full border-2 border-purple-200 text-purple-600 py-3 rounded-xl font-semibold hover:bg-purple-50 transition-all duration-300"
          >
            <i className="ri-questionnaire-line mr-2"></i>
            Remplir un autre questionnaire
          </button>
        </div>

        {/* Message additionnel */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            💡 N'hésitez pas à remplir le questionnaire à la fin de chaque journée de formation
          </p>
        </div>
      </div>
    </div>
  );
}